// Single source of truth for the LLM providers MyAgent supports.
// Consumed by the worker (RPC allowlist) and the UI (editor dropdown)
// so the two can't drift. To add a provider: append here + implement the
// adapter in llm-sdk.

export interface SupportedProvider {
  id: string
  displayName: string
}

export const SUPPORTED_PROVIDERS: readonly SupportedProvider[] = [
  { id: 'openai', displayName: 'OpenAI' },
  { id: 'gemini', displayName: 'Google Gemini' },
] as const

export const SUPPORTED_PROVIDER_IDS: readonly string[] = SUPPORTED_PROVIDERS.map(p => p.id)

export const isSupportedProvider = (id: string): boolean => SUPPORTED_PROVIDER_IDS.includes(id)
